import React, { useCallback, useEffect, useRef, useState } from "react";
import MobileHeader from "../MobileHeader/MobileHeader";
import { FETCH_POLICY, KATON_VIRTUAL_SCHOOL, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE } from "../../utils/constants";
import "./MobileScreenHeader.scss";
import { Tooltip } from "@mui/material";
import images from '../../assets/images';
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { GetChatCountResponse, GetClassroomUpdatesResponse, GetClassroomUpdatesVariables } from "../../pages/TeacherStudentClassroom/types/TeacherStudentClassroom";
import { GET_CHAT_INDICATION, GET_CLASSROOM_UPDATES } from "../../pages/TeacherStudentClassroom/api/TeacherStudentClassroomQuery";
import { useDispatch } from "react-redux";
import { setChatTabIndication, setTabIndication } from "../../redux/slices/indication";
import { MeetingCategoryType } from "../../pages/AdminPta/AdminPta";
import { useAppSelector } from "../../redux/app/hooks";
import ToasterWithMessage from "../toaster";
import { logout, setSplashvisible } from "../../redux/slices/authSlice";


interface ProfileData {
  schoolAdmin?: {
    nodes: Array<{
      saName: string;
    }>;
  };
  getCurrentUser?: {
    nodes: Array<{
      schoolAdminsByUId:{
        nodes: Array<{
          saId: string;
          saName: string;
          saNotificationEnabled: boolean;
          saWebsite: string;
          saEmailId: string;
          saDescription: string;
          saAvatarUrl: string;
          facilitatorsBySaId:{
            nodes: Array<{
              facId: string;
            }>;
          };
        }>;
      };
      studentsByUId?: {
        nodes: Array<{
          studentClassroomsBySId?: {
            nodes: Array<{
              classroomByCId?: {
                cName: string;
                cOriginalName: string;
              };
            }>;
          };
        }>;
      };
    }>;
  };
}

interface MobileScreenHeaderProps {
  profileImage?: string | null;
  role?: string | null;
  studentName?: string;
  classRoomName?: string;
  profile?: ProfileData;
  handleSearchClick?: () => void;
  favouriteIsOpen?:boolean
  setfavouriteIsOpen?:any
}

const MobileScreenHeader: React.FC<MobileScreenHeaderProps> = ({
  profileImage,
  role,
  studentName,
  classRoomName,
  profile,
  handleSearchClick,
  favouriteIsOpen,
  setfavouriteIsOpen
}) => {
    const [isOverflow, setIsOverflow] = useState(false);
    const schoolNameRef = useRef<HTMLDivElement | null>(null);
    const {backArrow} = images
    const location = useLocation();
    const [showPtaSideBar, setShowPtaSideBar] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selectedCategory: MeetingCategoryType = location?.state?.category;
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const schoolType = useAppSelector((state) => state.auth.schoolType);
    const isChime = process.env.REACT_APP_COMMON_CHAT_SERVICE === 'CHIME';
    const { error } = ToasterWithMessage();

    const [getClassRoomUpdates] = useLazyQuery<
            GetClassroomUpdatesResponse,
            GetClassroomUpdatesVariables
          >(GET_CLASSROOM_UPDATES, {
            fetchPolicy: FETCH_POLICY,
            onCompleted: (data) => {
              const { quiz, assignments, mylibrary, ebooks, isStudentHaveAccess } = data.getClassroomUpdates;
              if (role === STUDENT_ROLE && isStudentHaveAccess === false) {
                error("Your Access has been revoked!");
                setTimeout(() => {
                  dispatch(logout());
                  dispatch(setSplashvisible());
                }, 2000);
                return;
              }
              const quizCount = quiz.totalCount;
              const hasQuiz = quizCount > 0;
              const assignmentCount = assignments.totalCount;
              const hasAssignment = assignmentCount > 0;
              const myLibrayCount = mylibrary.totalCount;
              const ebooksCount = ebooks.totalCount;
              const hasMylibrary = myLibrayCount > 0;
              const hasEbooks = ebooksCount > 0;
        
              // Set tab indication based on either quiz or assignment presence
              dispatch(
                setTabIndication(hasQuiz || hasAssignment || hasMylibrary || hasEbooks)
              );
            },
            onError: (err) => {
              console.log(err.message);
            },
          });
        
          //indication for chat
          const [getIndicationChat] = useLazyQuery<
            GetChatCountResponse,
            GetClassroomUpdatesVariables
          >(GET_CHAT_INDICATION, {
            fetchPolicy: FETCH_POLICY,
            onCompleted: (data) => {
              const chatCount = data.getAllChatCount;
              const hasChat = chatCount > 0;
              dispatch(setChatTabIndication(hasChat));
            },
            onError: (err) => {
              console.log(err.message);
            },
          });

      //To check the container is overflow
      const checkOverflow = () => {
        if (schoolNameRef.current) {
          setIsOverflow(schoolNameRef.current.scrollWidth > schoolNameRef.current.clientWidth);
        }
      }
    
      //To check overflow in resize 
      useEffect(() => {
        window.addEventListener('resize', checkOverflow);
    
        return () => {
          window.removeEventListener('resize', checkOverflow);
        };
      }, []);
      

      const textRef = useRef<HTMLDivElement>(null);
      const [isEllipsisActive, setIsEllipsisActive] = useState(false);
    
      const checkEllipsis = useCallback(() => {
        if (textRef.current) {
          setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
        }
      }, []);
    
      useEffect(() => {
        checkEllipsis();
        window.addEventListener("resize", checkEllipsis);
        return () => window.removeEventListener("resize", checkEllipsis);
      }, [checkEllipsis, studentName]);

      const closeFavourites = ()=> {
        setfavouriteIsOpen(false)
      }

       const handleClickSchoolProfile = () => {
              if (location.pathname === '/teacher-pta' || location.pathname === '/pta-meetings') {
                setShowPtaSideBar(true);
              }
              if (location.pathname !== "/school-profile") {
                navigate("/school-profile", {
                  state: {
                    backNavigation: location.pathname,
                    category: selectedCategory
                  }
                });
              }
              if(role === STUDENT_ROLE){
                getClassRoomUpdates({
                  variables :{
                    cId : selectedClassRoomId ?? ''
                  }
                })
                // if(schoolType !== VIRTUAL){
                getIndicationChat({
                  variables: {
                    cId: selectedClassRoomId ?? "",
                    messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET'
                  },
                });
              // }
              }
            };

  return (
    <div className="mobile-screen-header-container">
      <div className="MobileScreenHeader">
        {!favouriteIsOpen && <div className={`MobileschoolProfileContainer`} onClick={handleClickSchoolProfile}>
          {profileImage && (
            <img className="mobileprofileImage" alt="ProfileImage" src={profileImage} />
          )}
          <div
            className="schoolProfileBottomContainer"
            style={{ gap: role === STUDENT_ROLE ? "8px" : "" }}
          >
            <Tooltip
                title={`${role === SCHOOL_ADMIN ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : KATON_VIRTUAL_SCHOOL : profile?.schoolAdmin?.nodes?.[0]?.saName ? profile?.schoolAdmin?.nodes?.[0]?.saName : KATON_VIRTUAL_SCHOOL}`}
                disableHoverListener={!isOverflow}
                placement="top"
            >
            <div className="schoolNameStyle" ref={schoolNameRef}>
              {(role === SCHOOL_ADMIN ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : profile?.schoolAdmin?.nodes?.[0]?.saName) || KATON_VIRTUAL_SCHOOL}
            </div>
            </Tooltip>
            {role === STUDENT_ROLE ? (
              <div className="studentTabStyle">
                <Tooltip title={isEllipsisActive ? studentName || "Student" : ""} >
      <div
        ref={textRef}
        className="student-name">
        {studentName || "Student"}
      </div>
    </Tooltip>
                <div className="namefield">
                  {profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]
                    ?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName && (
                    <div className="name-span">
                      {
                        profile.getCurrentUser.nodes[0].studentsByUId.nodes[0]
                          .studentClassroomsBySId.nodes[0].classroomByCId.cOriginalName
                      }
                    </div>
                  )}
                </div>
              </div>
            ) : role === TEACHER_ROLE ? (
              <div className="teacherTabStyle">
                <div>{studentName || "Teacher"}</div>
                <div>{classRoomName && <span>{classRoomName}</span>}</div>
              </div>
            ) : null}
          </div>
        </div>}
        {
          favouriteIsOpen && 
          <div className={`MobileschoolProfileContainer`}>
            <div onClick={closeFavourites}>
            <img className="headerBackIcon" src={backArrow} alt="backe=arrow" />
            </div>
            <div className="calender-name">Calendar</div>
            
          </div>
        }
        <MobileHeader handleSearchClick={handleSearchClick}/>
      </div>
     {!favouriteIsOpen && <span className="mobileHeaderSeperator"></span>}
    </div>
  );
};

export default MobileScreenHeader;
